interface BoxWithLockSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BoxWithLockSVG = ({ color, style }: BoxWithLockSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="50"
    viewBox="0 0 47 50"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13587)">
      <path
        d="M24.3028 19.3365L30.9189 23.1564L15.7246 31.9242L0.530273 23.1564L7.06108 19.3839"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9189 23.1564V40.7014L15.7246 49.4692L0.530273 40.7014V23.1564"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7246 31.9242V43.5829"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8145 13.1374L15.4969 15.5356L19.3737 10.8057"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7863 8.25594H8.66309V18.237H22.7863V8.25594Z"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.213 6.01896C21.213 2.98579 18.7486 0.521332 15.7154 0.521332C12.6822 0.521332 10.2178 2.98579 10.2178 6.01896"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2979 29.2512H37.7718V25.0616L45.8761 31.9242L37.7718 38.7962V34.5972H33.2979"
        stroke={color}
        strokeWidth="1.06161"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13587">
        <rect width="46.4076" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default BoxWithLockSVG;
